import classNames from 'classnames';
import FormRadioBtn from 'components/common/forms/FormRadioBtn';
import { useFormContext } from 'react-hook-form';
import styles from 'styles/pages/mypage/MypageInfoForm.module.scss';
import {
  MypageInfoFormFields,
  SchoolYearType,
  TMypageInfoForm,
} from 'types/form/mypage';

type TProps = {
  disabled?: boolean;
};

const SchoolYear = ({ disabled }: TProps) => {
  const { formState } = useFormContext<TMypageInfoForm>();
  const schoolYearError = formState.errors.schoolYear;

  return (
    <>
      <p className={classNames(styles.label, 'opacity_50')}>
        학년
        <span className="font_red fw700"> *</span>
      </p>
      <div className="mt24">
        <fieldset className={styles.radio_wrapper}>
          <FormRadioBtn
            name={MypageInfoFormFields.SchoolYear}
            value={SchoolYearType.SchoolYear1}
            labelText={SchoolYearType.SchoolYear1}
            labelStyle={{ opacity: 0.5 }}
            disabled={disabled}
          />
          <FormRadioBtn
            name={MypageInfoFormFields.SchoolYear}
            value={SchoolYearType.SchoolYear2}
            labelText={SchoolYearType.SchoolYear2}
            labelStyle={{ opacity: 0.5 }}
            disabled={disabled}
          />
          <FormRadioBtn
            name={MypageInfoFormFields.SchoolYear}
            value={SchoolYearType.SchoolYear3}
            labelText={SchoolYearType.SchoolYear3}
            labelStyle={{ opacity: 0.5 }}
            disabled={disabled}
          />
        </fieldset>
        {!schoolYearError && <div className={styles.div}></div>}
        {schoolYearError && (
          <p className="error_text">{schoolYearError?.message}</p>
        )}
      </div>
    </>
  );
};

export default SchoolYear;
